export default __webpack_public_path__ + "static/media/Balthus's Woodsman Bracers.3f29bce8.jpg";